import React,{useRef,useState,useEffect} from 'react'
import style1 from './vediofolder/styles/main.css'
import style2 from './vediofolder/styles/room.css'
import AgoraRTC from 'agora-rtc-sdk-ng';
import AgoraRTM from 'agora-rtm-sdk';
import {Navigate,useNavigate} from 'react-router-dom'
import { useCookies } from 'react-cookie';
import ReactLoading from 'react-loading';
import clickSound from './Assets/frontend_src_assets_clickSound_clickSound.mp3'
import { Toast } from '@chakra-ui/react';
// import AgoraRTM from 'agora-rtm-sdk';
// import AgoraRTC from 'agora-rtc-sdk';

// import {createMicrophoneAndCameraTracks} from 'agora-rtc-sdk';

function Room() {
    const [cookies] = useCookies(['participateEmail','email','password','adminstatus']);
    const [isloading,setLoading] = useState(false)
    const [chatHistory, setChatHistory] = useState(() => {
        // Get chat history from local storage or set an empty array if no history found
        const storedHistory = localStorage.getItem('chatHistory');
        return storedHistory ? JSON.parse(storedHistory) : [];
      });
      const [hideVedio,setHideVedio]=useState(false)

      function vedioHide(){
        setHideVedio(!hideVedio)

        // if(hideVedio){
        //     let streamContainer = document.getElementById('streams__container')
        //     let addIcon=`<div class="iconAdd">
        //     <img src="./Auction.png"/>
            
        // </div>`
        // streamContainer.insertAdjacentHTML('beforeend',addIcon)
        //   }
      }
      


      const addMessageToChatHistory = (name, message) => {
        const newMessage = { name, message };
        setChatHistory((prevChatHistory) => [...prevChatHistory, newMessage]);
        // Save the updated chat history to local storage
        localStorage.setItem('chatHistory', JSON.stringify([...chatHistory, newMessage]));
      };


    const messagesContainerRef = useRef(null);

    const APP_ID = "da7cf6e05cd84f8a8629ad3b59be040f"
    // c86cddd07b61445bbffcb6550c766dfb
    // da7cf6e05cd84f8a8629ad3b59be040f
    // da7cf6e05cd84f8a8629ad3b59be040f
    const audioConfig = {
        // Microphone audio track configuration options
        // For example, you can specify the sample rate, channel count, etc.
      };
    //   AgoraRTC.Logger.setLogLevel(1);

      const videoConfig = {
        encoderConfig: {
          width: {
            min: 640,
            ideal: 1920,
            max: 1920
          },
          height: {
            min: 480,
            ideal: 1080,
            max: 1080
          }
        }
      };
      const email = cookies.email;
      const password=cookies.password
const ownerEmail = cookies.participateEmail;
const adminEmail=cookies.adminstatus
const playSound = () => {
    const sound = new Audio(clickSound);
    sound.play();
  };
  console.log(playSound,"playSound")

const navigate=useNavigate()



const exitAuction=async ()=>{
playSound()
window.location.href="/participate"
// navigate("/participate")
}


    useEffect(() => {
        // setTimeout(() => {
        //     setLoading(false);
        //   }, 2000);
      const messagesContainer = messagesContainerRef.current;
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
   


//     let messagesContainer = document.getElementById('messages');
// messagesContainer.scrollTop = messagesContainer.scrollHeight;


let displayName = sessionStorage.getItem('display_name')
console.log(displayName,"jeeee")
if(!displayName ){
    // window.location = <Lobby/>
    // return <Navigate to="/lobby"/>
    window.location.href="/lobby"
}

const memberContainer = document.getElementById('members__container');
const memberButton = document.getElementById('members__button');

const chatContainer = document.getElementById('messages__container');
const chatButton = document.getElementById('chat__button');

let activeMemberContainer = false;

memberButton.addEventListener('click', () => {

// function handleMember(){
    if (activeMemberContainer) {
      memberContainer.style.display = 'none';
    } else {
      memberContainer.style.display = 'block';
    }
  
    activeMemberContainer = !activeMemberContainer;

// }
// expandVideoFrame()
});

let activeChatContainer = false;

chatButton.addEventListener('click', () => {

    // function handleChat(){
        if (activeChatContainer) {
          chatContainer.style.display = 'none';
        } else {
          chatContainer.style.display = 'block';
        }
      
        activeChatContainer = !activeChatContainer;

    // }
});

let displayFrame = document.getElementById('stream__box')
let videoFrames = document.getElementsByClassName('video__container')

let userIdInDisplayFrame = null;

// let expandVideoFrame = (e) => {

//   let child = displayFrame.children[0]
//   if(child){
//       document.getElementById('streams__container').appendChild(child)
//   }

//   displayFrame.style.display = 'block'
//   displayFrame.appendChild(e.currentTarget)
//   userIdInDisplayFrame = e.currentTarget.id

//   for(let i = 0; videoFrames.length > i; i++){
//     if(videoFrames[i].id != userIdInDisplayFrame){
//       videoFrames[i].style.height = '100px'
//       videoFrames[i].style.width = '100px'
//     }
//   }

// }

// for(let i = 0; videoFrames.length > i; i++){
//   videoFrames[i].addEventListener('click', expandVideoFrame)
// }

//  set the vedio frame here
let hideDisplayFrame = () => {
    console.log("hidedisplay")
    userIdInDisplayFrame = null
    displayFrame.style.display = null

    let child = displayFrame.children[0]
    document.getElementById('streams__container').appendChild(child)

    for(let i = 0; videoFrames.length > i; i++){
      videoFrames[i].style.height = '300px'
      videoFrames[i].style.width = '300px'
  }
}

// displayFrame.addEventListener('click', hideDisplayFrame)

// ...

let handleMemberJoined = async (MemberId) => {
    console.log('A new member has joined the room:', MemberId)
    addMemberToDom(MemberId)

    let members = await channel.getMembers()
    updateMemberTotal(members)

    let {name} = await rtmClient.getUserAttributesByKeys(MemberId, ['name'])
    if(name!==undefined){
        addBotMessageToDom(`Welcome to the room ${name}! 👋`)

    }else{
        addBotMessageToDom(`Welcome to the room ! 👋`)
    }
}

let addMemberToDom = async (MemberId) => {
    let {name} = await rtmClient.getUserAttributesByKeys(MemberId, ['name'])

    let membersWrapper = document.getElementById('member__list')
    let memberItem = `<div class="member__wrapper" id="member__${MemberId}__wrapper">
                        <span class="green__icon"></span>
                        <p class="member_name">${name}</p>
                    </div>`

    membersWrapper.insertAdjacentHTML('beforeend', memberItem)
}

let updateMemberTotal = async (members) => {
    let total = document.getElementById('members__count')
    total.innerText = members.length
}
 
let handleMemberLeft = async (MemberId) => {
    removeMemberFromDom(MemberId)

    let members = await channel.getMembers()
    updateMemberTotal(members)
}

let removeMemberFromDom = async (MemberId) => {
    let memberWrapper = document.getElementById(`member__${MemberId}__wrapper`)
    let name = memberWrapper.getElementsByClassName('member_name')[0].textContent
    if(name!==undefined){
        addBotMessageToDom(`${name} has left the room.`)

    }else{
        addBotMessageToDom(` someone has left the room.`)
    }
        
    memberWrapper.remove()
}

let getMembers = async () => {
    let members = await channel.getMembers()
    updateMemberTotal(members)
    for (let i = 0; members.length > i; i++){
        addMemberToDom(members[i])
    }
}

let handleChannelMessage = async (messageData, MemberId) => {
    console.log('A new message was received')
    let data = JSON.parse(messageData.text)

    if(data.type === 'chat'){
        addMessageToDom(data.displayName, data.message)
    }

    if(data.type === 'user_left'){
        document.getElementById(`user-container-${data.uid}`).remove()

        if(userIdInDisplayFrame === `user-container-${uid}`){
            displayFrame.style.display = null
    
            for(let i = 0; videoFrames.length > i; i++){
                videoFrames[i].style.height = '300px'
                videoFrames[i].style.width = '300px'
            }
        }
    }
}


// send message function
let sendMessage = async (e) => {
    e.preventDefault()
    console.log("sendmessage")

    let message = e.target.message.value
    if(message){
        channel.sendMessage({text:JSON.stringify({'type':'chat', 'message':message, 'displayName':displayName})})
        console.log(channel,"channel")
        // addMessageToChatHistory(displayName, message)
        addMessageToDom(displayName, message)
        e.target.reset()

    }else{
        // toast({
        //     title: "Login failed !",
        //     description: "please check email or password",
        //     status: "error",
        //     duration: 9000,
        //     isClosable: true,
        //     position: "top-right",
        //   });

        // alert("add messages")
    }
}


//  add message to dom
let addMessageToDom = (name, message) => {
    console.log("addMessageToDom")
    let messagesWrapper = document.getElementById('messages')

    let newMessage = `<div class="message__wrapper">
                        <div class="message__body">
                            <strong class="message__author">${name}</strong>
                            <p class="message__text">${message}</p>
                        </div>
                    </div>`

    messagesWrapper.insertAdjacentHTML('beforeend', newMessage)

    

    

    let lastMessage = document.querySelector('#messages .message__wrapper:last-child')
    if(lastMessage){
        lastMessage.scrollIntoView()
    }
}


//  add bot message 
let addBotMessageToDom = (botMessage) => {
    let messagesWrapper = document.getElementById('messages')

    let newMessage = `<div class="message__wrapper">
                        <div class="message__body__bot">
                            <strong class="message__author__bot">🤖 Malak-Bot</strong>
                            <p class="message__text__bot">${botMessage}</p>
                        </div>
                    </div>`

    messagesWrapper.insertAdjacentHTML('beforeend', newMessage)

    let lastMessage = document.querySelector('#messages .message__wrapper:last-child')
    if(lastMessage){
        lastMessage.scrollIntoView()
    }
}

let leaveChannel = async () => {
    await channel.leave()
    await rtmClient.logout()
}

window.addEventListener('beforeunload', leaveChannel)
let messageForm = document.getElementById('message__form')
messageForm.addEventListener('submit', sendMessage)



//  store user id to session storage
let uid = sessionStorage.getItem('uid')
if(!uid){
    console.log("uuuuuiiiidddd")
    uid = String(Math.floor(Math.random() * 10000))
    sessionStorage.setItem('uid', uid)
}

let token = null;
let client;

let rtmClient;
let channel;

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
let roomId = urlParams.get('room')

if(!roomId){
    roomId = 'main'
}



let localTracks = []
let remoteUsers = {}

let localScreenTracks;
let sharingScreen = false;

let joinRoomInit = async () => {
    rtmClient = await AgoraRTM.createInstance(APP_ID)
    await rtmClient.login({uid,token})

    await rtmClient.addOrUpdateLocalUserAttributes({'name':displayName})

    channel = await rtmClient.createChannel(roomId)
    await channel.join()

    channel.on('MemberJoined', handleMemberJoined)
    channel.on('MemberLeft', handleMemberLeft)
    channel.on('ChannelMessage', handleChannelMessage)

    getMembers()
    addBotMessageToDom(`Welcome to the room ${displayName}! 👋`)

    client = AgoraRTC.createClient({mode:'rtc', codec:'vp8'})
    await client.join(APP_ID, roomId, token, uid)

    client.on('user-published', handleUserPublished)
    client.on('user-left', handleUserLeft)
}

let joinStream = async () => {
    console.log("join")
    if(adminEmail==="admin"){
        document.getElementById('join-btn').style.display = 'none'

    }
    
    document.getElementsByClassName('stream__actions')[0].style.display = 'flex'

    localTracks = await AgoraRTC.createMicrophoneAndCameraTracks({}, {encoderConfig:{
        width:{min:640, ideal:1920, max:1920},
        height:{min:480, ideal:1080, max:1080}
    }})


    let player = `<div class="video__container" id="user-container-${uid}" >
                    <div class="video-player" id="user-${uid}"></div>
                 </div>`

    document.getElementById('streams__container').insertAdjacentHTML('beforeend', player)
    // document.getElementById(`user-container-${uid}`).addEventListener('click', expandVideoFrame)

    localTracks[1].play(`user-${uid}`)
    await client.publish([localTracks[0], localTracks[1]])
}

let switchToCamera = async () => {
    let player = `<div class="video__container" id="user-container-${uid}">
                    <div class="video-player" id="user-${uid}"></div>
                 </div>`
    displayFrame.insertAdjacentHTML('beforeend', player)

    await localTracks[0].setMuted(true)
    await localTracks[1].setMuted(true)

    document.getElementById('mic-btn').classList.remove('active')
    // document.getElementById('screen-btn').classList.remove('active')

    localTracks[1].play(`user-${uid}`)
    await client.publish([localTracks[1]])
}

let handleUserPublished = async (user, mediaType) => {
    remoteUsers[user.uid] = user

    await client.subscribe(user, mediaType)

    let player = document.getElementById(`user-container-${user.uid}`)
    if(player === null){
        player = `<div class="video__container" id="user-container-${user.uid}">
                <div class="video-player" id="user-${user.uid}"></div>
            </div>`

        document.getElementById('streams__container').insertAdjacentHTML('beforeend', player)
        // document.getElementById(`user-container-${user.uid}`).addEventListener('click', expandVideoFrame)
   
    }

    if(displayFrame.style.display){
        let videoFrame = document.getElementById(`user-container-${user.uid}`)
        videoFrame.style.height = '100px'
        videoFrame.style.width = '100px'
    }

    if(mediaType === 'video'){
        user.videoTrack.play(`user-${user.uid}`)
    }

    if(mediaType === 'audio'){
        user.audioTrack.play()
    }

}

let handleUserLeft = async (user) => {
    delete remoteUsers[user.uid]
    let item = document.getElementById(`user-container-${user.uid}`)
    if(item){
        item.remove()
    }

    if(userIdInDisplayFrame === `user-container-${user.uid}`){
        displayFrame.style.display = null
        
        let videoFrames = document.getElementsByClassName('video__container')

        for(let i = 0; videoFrames.length > i; i++){
            videoFrames[i].style.height = '300px'
            videoFrames[i].style.width = '300px'
        }
    }
}

let toggleMic = async (e) => {
    let button = e.currentTarget

    if(localTracks[0].muted){
        await localTracks[0].setMuted(false)
        button.classList.add('active')
    }else{
        await localTracks[0].setMuted(true)
        button.classList.remove('active')
    }
}

let toggleCamera = async (e) => {
    let button = e.currentTarget

    if(localTracks[1].muted){
        await localTracks[1].setMuted(false)
        button.classList.add('active')
    }else{
        await localTracks[1].setMuted(true)
        button.classList.remove('active')
    }
}

let toggleScreen = async (e) => {
    let screenButton = e.currentTarget
    let cameraButton = document.getElementById('camera-btn')

    if(!sharingScreen){
        sharingScreen = true

        screenButton.classList.add('active')
        cameraButton.classList.remove('active')
        cameraButton.style.display = 'none'

        localScreenTracks = await AgoraRTC.createScreenVideoTrack()

        document.getElementById(`user-container-${uid}`).remove()
        displayFrame.style.display = 'block'

        let player = `<div class="video__container" id="user-container-${uid}">
                <div class="video-player" id="user-${uid}"></div>
            </div>`

        displayFrame.insertAdjacentHTML('beforeend', player)
        // document.getElementById(`user-container-${uid}`).addEventListener('click', expandVideoFrame)

        userIdInDisplayFrame = `user-container-${uid}`
        localScreenTracks.play(`user-${uid}`)

        await client.unpublish([localTracks[1]])
        await client.publish([localScreenTracks])

        let videoFrames = document.getElementsByClassName('video__container')
        for(let i = 0; videoFrames.length > i; i++){
            if(videoFrames[i].id != userIdInDisplayFrame){
              videoFrames[i].style.height = '100px'
              videoFrames[i].style.width = '100px'
            }
          }


    }else{
        sharingScreen = false 
        cameraButton.style.display = 'block'
        document.getElementById(`user-container-${uid}`).remove()
        await client.unpublish([localScreenTracks])

        switchToCamera()
    }
}

let leaveStream = async (e) => {
    e.preventDefault()
    if(adminEmail==="admin"){
        document.getElementById('join-btn').style.display = 'block'

    }

    document.getElementsByClassName('stream__actions')[0].style.display = 'none'

    for(let i = 0; localTracks.length > i; i++){
        localTracks[i].stop()
        localTracks[i].close()
    }

    await client.unpublish([localTracks[0], localTracks[1]])

    if(localScreenTracks){
        await client.unpublish([localScreenTracks])
    }

    document.getElementById(`user-container-${uid}`).remove()

    if(userIdInDisplayFrame === `user-container-${uid}`){
        displayFrame.style.display = null

        for(let i = 0; videoFrames.length > i; i++){
            videoFrames[i].style.height = '300px'
            videoFrames[i].style.width = '300px'
        }
    }
    setHideVedio(false)

    channel.sendMessage({text:JSON.stringify({'type':'user_left', 'uid':uid})})
}

document.getElementById('camera-btn').addEventListener('click', toggleCamera)
document.getElementById('mic-btn').addEventListener('click', toggleMic)
document.getElementById('screen-btn').addEventListener('click', toggleScreen)
if(adminEmail==="admin"){
    document.getElementById('join-btn').addEventListener('click', joinStream)

}
document.getElementById('leave-btn').addEventListener('click', leaveStream)


joinRoomInit()

}, []);



  return (
    <>
      <div id="mainroom" >

      <header id="nav" style={{background:"none"}}>
        <div className="nav--list">
             <button id="members__button" style={{backgroundColor:"white"}} >
               {/* jejeee */}
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M24 18v1h-24v-1h24zm0-6v1h-24v-1h24zm0-6v1h-24v-1h24z" fill="red"/><path d="M24 19h-24v-1h24v1zm0-6h-24v-1h24v1zm0-6h-24v-1h24v1z"/></svg>
             </button>
        </div>
 
         <div id="nav__links">
             <button id="chat__button" ><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" fill="#ede0e0" clip-rule="evenodd"><path d="M24 20h-3v4l-5.333-4h-7.667v-4h2v2h6.333l2.667 2v-2h3v-8.001h-2v-2h4v12.001zm-15.667-6l-5.333 4v-4h-3v-14.001l18 .001v14h-9.667zm-6.333-2h3v2l2.667-2h8.333v-10l-14-.001v10.001z"/></svg></button> 
          </div> 
      </header>
 
     <main className="container"   >
         <div id="room__container" style={{height:"100vh",width:"100%",position:"fixed"}}  >
 
             <section id="members__container">
 
             <div id="members__header">
                 <p>Live  Participants</p>
                 <strong id="members__count">0</strong>
             </div>
 
             <div id="member__list">
             </div>
 
             </section>
 
             <section id="stream__container" >
             {hideVedio && <img  src="./Auction.png" alt="Hidden Video" />}
 
                 <div id="stream__box"  ></div>
 
                 {/* <div id="streams__container"  >  */}
                {/* {hideVedio && <img src="./Auction.png" />} */}
                 {/* </div> */}
                 <div id="streams__container">
                {/* Conditionally render the image */}
                
              </div>
 
                 <div className="stream__actions">
                     <button id="camera-btn" className="active" onClick={vedioHide}  >
                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 4h-3v-1h3v1zm10.93 0l.812 1.219c.743 1.115 1.987 1.781 3.328 1.781h1.93v13h-20v-13h3.93c1.341 0 2.585-.666 3.328-1.781l.812-1.219h5.86zm1.07-2h-8l-1.406 2.109c-.371.557-.995.891-1.664.891h-5.93v17h24v-17h-3.93c-.669 0-1.293-.334-1.664-.891l-1.406-2.109zm-11 8c0-.552-.447-1-1-1s-1 .448-1 1 .447 1 1 1 1-.448 1-1zm7 0c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0-2c-2.761 0-5 2.239-5 5s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5z"/></svg>
                     </button>
                     <button id="mic-btn" className="active" >
                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 2c1.103 0 2 .897 2 2v7c0 1.103-.897 2-2 2s-2-.897-2-2v-7c0-1.103.897-2 2-2zm0-2c-2.209 0-4 1.791-4 4v7c0 2.209 1.791 4 4 4s4-1.791 4-4v-7c0-2.209-1.791-4-4-4zm8 9v2c0 4.418-3.582 8-8 8s-8-3.582-8-8v-2h2v2c0 3.309 2.691 6 6 6s6-2.691 6-6v-2h2zm-7 13v-2h-2v2h-4v2h10v-2h-4z"/></svg>
                     </button>
                     <button id="screen-btn">
                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 1v17h24v-17h-24zm22 15h-20v-13h20v13zm-6.599 4l2.599 3h-12l2.599-3h6.802z"/></svg>
                     </button>
                     <button id="leave-btn" style={{backgroundColor: "#FF5050;"}} >
                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16 10v-5l8 7-8 7v-5h-8v-4h8zm-16-8v20h14v-2h-12v-16h12v-2h-14z"/></svg>
                     </button>
                 </div>
                 {adminEmail==="admin" ? <button id="join-btn" > Join Room</button> : <button id="exit-btn" onClick={exitAuction} > Exit Auction </button> }
 
                 
             </section>
 
             <section id="messages__container" >
 
                 <div id="messages" ref={messagesContainerRef}>
                 {/* {chatHistory.map((messageData, index) => (
            <div key={index} className="message__wrapper">
              <div className="message__body">
                <strong className="message__author">{messageData.name}</strong>
                <p className="message__text">{messageData.message}</p>
              </div>
            </div>
          ))} */}
                 </div>
 
 
                 <form id="message__form"  style={{display:"flex",gap:"20px"}}>
                     <input type="text" name="message" placeholder="Send a message...." />
                              <button><img src="https://cdn-icons-png.flaticon.com/128/9590/9590887.png" alt="send icons" style={{ height: '50px', width:"50px"}}/></button>
                 </form>
 
             </section>
         </div>
     </main>
     
 </div>
    </>
    
    

    
  )
}

export default Room





